import { IPartnerFinSobRow } from '../../model/types'

import { OVERALL_CATEGORY } from './constants'
import { isRequestedCategoryRow } from './isRequestedCategoryRow'
import { TCategoryRowScope } from './types'

interface IParams {
  rows: IPartnerFinSobRow[]
  selectedFYear: number
  category?: string
  categoryRowScope?: TCategoryRowScope
}

export const getPlanRows = ({
  rows,
  selectedFYear,
  category = OVERALL_CATEGORY,
  categoryRowScope = 'total',
}: IParams): IPartnerFinSobRow[] =>
  rows.filter(
    (row) => row.fYear === selectedFYear && isRequestedCategoryRow(row, category, categoryRowScope)
  )
